/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>mediator.service.ts</name>
///
/// <description>
///  The mediator service will mediate events between the various UI entities
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sep16 MM  1.0.0000         First cut
/// 28Sep16 YH  1.0.1            Implement events hashtable 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable, Input } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {Http, Response} from '@angular/http';
import {MockBackend} from '@angular/http/testing';

@Injectable()
export class MediatorService {

    private _events : EventsHashTable<Subject<any>> = {};

    public Action(eventName:string, payload:any): void {
        let event: Subject<any> = this._events[eventName];
        if (event !== null && typeof event !== 'undefined')  {
            event.next(payload);
        }
    }

    public Event(eventName:string): Observable<any> {
        let event: Subject<any> = this._events[eventName];
        if (event === null || typeof event === 'undefined')  {
            event = new Subject<any>();
            this._events[eventName] = event;
        } 
        return event.asObservable();
    } 

    public ClearEvent(eventName:string):void {
        delete this._events[eventName];
    }
}

interface EventsHashTable<T> {
    [key: string]: T;
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/mediator.service.ts